import React from 'react'
import { compose } from 'redux'
import hasDropzones from '../../hoc/hasDropzones'
import DragSourceWrapperWithDropzonesContainer from './DragSourceWrapperContainer'

export default compose(
    hasDropzones()
)(DragSourceWrapperWithDropzonesContainer)